import { MODULES, USER_TYPES } from './constants';

const COOKBOOK_V1 = {
  id: 'v1',
  defaultPath: '/survey/entry',
  recipes: {
    [MODULES.SURVEY]: {
      name: MODULES.SURVEY,
      modulePath: '/survey/*',
      defaultPath: '/survey/entry',
      variants: {
        [USER_TYPES.CLIENT]: {
          sequence: ['/survey/entry', '/survey/manage', '/survey/roles'],
          next: '/account/create_professional',
        },
        [USER_TYPES.FAMILY]: {
          sequence: [
            '/survey/entry',
            '/survey/manage',
            '/survey/card_for',
            '/survey/trustee',
            '/survey/thanks',
          ],
          next: '/account/create_family',
        },
        [USER_TYPES.MYSELF]: {
          sequence: ['/survey/entry', '/survey/manage'],
          next: '/account/create_self',
        },
      },
    },
    [MODULES.CREDENTIALS]: {
      name: MODULES.CREDENTIALS,
      modulePath: '/account/*',
      defaultPath: '/account/create',
      variants: {
        [USER_TYPES.CLIENT]: {
          sequence: ['/account/create_professional'],
          next: '/admin/profile',
        },
        [USER_TYPES.FAMILY]: {
          sequence: ['/account/create_family'],
          next: '/admin/profile',
        },
        [USER_TYPES.MYSELF]: {
          sequence: ['/account/create_self'],
          next: '/admin/profile',
        },
      },
    },
    [MODULES.ADMIN]: {
      name: MODULES.ADMIN,
      modulePath: '/admin/*',
      defaultPath: '/admin/profile',
      variants: {
        [USER_TYPES.CLIENT]: {
          sequence: ['/admin/profile', '/admin/business'],
          next: '/card_order/cardholder_profile',
        },
        [USER_TYPES.FAMILY]: {
          sequence: ['/admin/profile'],
          next: '/card_order/cardholder_profile',
        },
        [USER_TYPES.MYSELF]: {
          sequence: ['/admin/profile'],
          next: '/card_order/card_program',
        },
      },
    },
    [MODULES.IDV]: {
      name: MODULES.IDV,
      modulePath: '/idv/*',
      defaultPath: '/idv/verify',
      variants: {
        [USER_TYPES.CLIENT]: {
          sequence: ['/idv/verify'],
          next: '/card_order/cardholder_profile',
          alternativeNext: {
            sntFlow: '/shipping',
          },
        },
        [USER_TYPES.FAMILY]: {
          sequence: ['/idv/verify'],
          next: '/review/review_order',
          alternativeNext: {
            differentAddress: '/shipping',
            sameAddress: '/review/review_order',
          },
        },
        [USER_TYPES.MYSELF]: {
          sequence: ['/idv/verify'],
          next: '/review/review_order',
        },
      },
    },
    [MODULES.CARD_ORDER]: {
      name: MODULES.CARD_ORDER,
      modulePath: '/card_order/*',
      defaultPath: '/card_order/cardholder_profile',
      variants: {
        [USER_TYPES.CLIENT]: {
          sequence: ['/card_order/cardholder_profile', '/card_order/card_program'],
          next: '/shipping',
          alternativeNext: {
            sntFlow: '/trust/trust_details',
          },
        },
        [USER_TYPES.FAMILY]: {
          sequence: ['/card_order/cardholder_profile', '/card_order/card_program'],
          next: '/shipping',
          alternativeNext: {
            sntFlow: '/idv/verify',
            sameAddress: '/review/review_order',
          },
        },
        [USER_TYPES.MYSELF]: {
          sequence: ['/card_order/card_program'],
          next: '/idv/verify',
        },
      },
    },
    [MODULES.TRUST]: {
      name: MODULES.TRUST,
      modulePath: '/trust/*',
      defaultPath: '/trust/trust_details',
      variants: {
        [USER_TYPES.CLIENT]: {
          sequence: ['/trust/trust_details'],
          next: '/idv/verify',
        },
      },
    },
    [MODULES.SHIPPING]: {
      name: MODULES.SHIPPING,
      modulePath: '/shipping',
      defaultPath: '/shipping',
      variants: {
        [USER_TYPES.CLIENT]: {
          sequence: ['/shipping'],
          next: '/review/review_order',
        },
        [USER_TYPES.FAMILY]: {
          sequence: ['/shipping'],
          next: '/review/review_order',
        },
      },
    },
    [MODULES.REVIEW]: {
      name: MODULES.REVIEW,
      modulePath: '/review/*',
      defaultPath: '/review/review_order',
      variants: {
        [USER_TYPES.CLIENT]: {
          sequence: ['/review/review_order', '/review/success'],
          next: '',
        },
        [USER_TYPES.FAMILY]: {
          sequence: ['/review/review_order', '/review/success'],
          next: '',
        },
        [USER_TYPES.MYSELF]: {
          sequence: ['/review/review_order', '/review/success'],
          next: '',
        },
      },
    },
  },
};

export default COOKBOOK_V1;
